export default "__VITE_PUBLIC_ASSET__9b44f2e1__"